import Head from 'next/head';
import { okToShopInfoStylesCss } from './OkToShopInfo.style';

export const OkToShopInfoHead = () => {
  return (
    <Head>
      <script type="text/javascript" defer src="https://api.okto.shop/js/oktoshop_snippet-1.0.3.min.js" />
      <style type="text/css">{okToShopInfoStylesCss}</style>
    </Head>
  );
};
